import { IconAlignCenter } from '@doltech/icons-from-dev/action/IconAlignCenter';
import { IconAlignLeft } from '@doltech/icons-from-dev/action/IconAlignLeft';
import { IconAlignRight } from '@doltech/icons-from-dev/action/IconAlignRight';
import { IconReplaceImage } from '@doltech/icons-from-dev/action/IconReplaceImage';
import { IconContentTrash } from '@doltech/icons/IconContentTrash';
import cl from 'classnames';
import dynamic from 'next/dynamic';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../../../colors-v2';
import { showToast } from '../../../Toast';
import { ImageAlignEnum } from './ImageAlignEnum';

const DefaultPrivateImageUpload = dynamic<any>(
  import('../../../FileUpload').then((mod) => mod.DefaultPrivateFileUpload),
  { ssr: false }
);

const Main = styled.div`
  padding: 8px 12px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .ic-wrapper {
    cursor: pointer;
    margin-right: 14px;
    font-size: 24px;
    line-height: 0;
    color: ${colorsV2.black40};
    .ant-upload {
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }
    &:hover,
    &.active {
      color: ${colorsV2.white100};
    }
    &:last-child {
      margin-right: 0;
    }
  }
  .vertical-separator {
    width: 1px;
    background: ${colorsV2.white10};
    margin-right: 14px;
    height: 24px;
  }
`;

export interface TooltipAlignImageProps extends React.HTMLAttributes<HTMLDivElement> {
  currentAlignment: ImageAlignEnum;
  onClickAlignRight?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClickAlignCenter?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClickAlignLeft?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onClickDelete?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  onReplaceImageUploadingStateChange?: (uploading: boolean) => void;
  onReplaceImageSuccess?: (image: any) => void;
}

export const TooltipAlignImage = (props: TooltipAlignImageProps) => {
  const {
    currentAlignment,
    onClickAlignRight,
    onClickAlignCenter,
    onClickAlignLeft,
    onClickDelete,
    onReplaceImageUploadingStateChange,
    onReplaceImageSuccess,
    ...rest
  } = props;
  const icWrapperClassName = 'ic-wrapper';
  return (
    <Main {...rest}>
      <div
        role="button"
        aria-hidden="true"
        onClick={onClickAlignLeft}
        className={cl(icWrapperClassName, {
          active: currentAlignment === ImageAlignEnum.ALIGN_LEFT,
        })}
      >
        <IconAlignRight />
      </div>
      <div
        role="button"
        aria-hidden="true"
        onClick={onClickAlignCenter}
        className={cl(icWrapperClassName, {
          active: currentAlignment === ImageAlignEnum.ALIGN_CENTER,
        })}
      >
        <IconAlignCenter />
      </div>
      <div
        role="button"
        aria-hidden="true"
        onClick={onClickAlignRight}
        className={cl(icWrapperClassName, {
          active: currentAlignment === ImageAlignEnum.ALIGN_RIGHT,
        })}
      >
        <IconAlignLeft />
      </div>
      <div className="vertical-separator" />
      <div className="ic-wrapper">
        <DefaultPrivateImageUpload
          showUploadList={false}
          onProgress={() => {
            onReplaceImageUploadingStateChange(true);
          }}
          onSuccess={(res, originalFile) => {
            onReplaceImageUploadingStateChange(false);
            const { tokenResponse } = res;
            const { path, downloadResourceUrl } = tokenResponse;
            const replacedImage = {
              url: downloadResourceUrl,
              path,
              name: res.file.name,
              size: res.file.size,
              uploadedDate: res.file.uploadedDate,
              file: originalFile,
            };
            onReplaceImageSuccess(replacedImage);
          }}
          onError={(err) => {
            onReplaceImageUploadingStateChange(false);
            showToast({
              icon: 'danger',
              title: 'file upload failed',
              subTitle: err.message,
            });
          }}
        >
          <IconReplaceImage />
        </DefaultPrivateImageUpload>
      </div>
      <div role="button" aria-hidden="true" onClick={onClickDelete} className="ic-wrapper">
        <IconContentTrash />
      </div>
    </Main>
  );
};
